export default __webpack_public_path__ + "static/media/blue_marker_linear_sci1_spritesheet.5d5cf488.png";